import { createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useArbeitszeitById } from '../../hooks/useArbeitszeitById';
import { Antrag, Arbeitszeit } from '../../entities';

export type EditSheetContextProps = {
  arbeitszeit: Arbeitszeit & { antraege?: Antrag[] };
};

export const EditSheetContext = createContext<
  EditSheetContextProps | undefined
>(undefined);

function EditSheetContextProvider({ children }: { children: React.ReactNode }) {
  const { arbeitszeitId } = useParams();
  const { arbeitszeit } = useArbeitszeitById(arbeitszeitId);

  return (
    <EditSheetContext.Provider value={{ arbeitszeit }}>
      {children}
    </EditSheetContext.Provider>
  );
}

function useEditSheetContext() {
  const editSheetContext = useContext(EditSheetContext);

  if (editSheetContext === undefined) {
    throw new Error(
      'useAuthenticationContext must be used within AuthenticationContextProvider',
    );
  }
  return editSheetContext;
}

// eslint-disable-next-line react-refresh/only-export-components
export { useEditSheetContext, EditSheetContextProvider };
